// extracted by mini-css-extract-plugin
export default {"galleryGrid":"Gallery_galleryGrid__ApoyL","bookGalleryGrid":"Gallery_bookGalleryGrid__HCpwx"};